import { useTranslation } from 'react-i18next';

import GlobalSearchModal from '../components/GlobalSearch/GlobalSearchModal';

import { defaultButtonsProps, useModals } from '../contexts/ModalContext';

interface GlobalSearchProps {
  /**
   * Test id for global search modal
   */
  testId?: string;
}

const useGlobalSearch = ({ testId = '' }: GlobalSearchProps) => {
  const { t } = useTranslation();
  const modal = useModals();

  return async () =>
    modal({
      id: 'global-search',
      content: <GlobalSearchModal testId={testId} />,
      buttons: [
        {
          ...defaultButtonsProps.cancel,
          label: t('Global.Close'),
          result: true,
          key: 'Close',
        },
      ],
      size: 'xl',
      dialogAdditionalClasses: 'self-start mt-5 max-h-[calc(100vh-2.5rem)]',
    });
};

export default useGlobalSearch;
